@if (!loading()) {
  <form [formGroup]="supplierComplaintSendForm()" id="supplierComplaintSendForm" (ngSubmit)="onSubmit()" class="no-padding">
    <div class="grid card-body gap-24">
      <div class="g-col-8 gap-24 border-right-1 border-color-neutral-200 p-24">
        <div class="d-flex flex-column g-col-12 g-col-lg-12">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label labelCssClass="k-form-label" [for]="subject" [text]="'SUBJECT' | translate | capitalize" />
            <kendo-textbox [rcDisabled]="true" rcValidation #subject formControlName="subject" />
          </kendo-formfield>
        </div>

        <div class="d-flex g-col-12 g-col-lg-12 flex-grow-1">
          <kendo-formfield class="d-flex flex-column flex-grow-1" showHints="initial" showErrors="initial">
            <kendo-label labelCssClass="k-form-label" [for]="body" [text]="'MESSAGE' | translate | capitalize" />
            <kendo-editor rcValidation #body formControlName="body" class="border-radius-4 d-flex grow-editor confirmation-editor" [iframeCss]="cssSettings">
              <kendo-toolbar class="border-top-left-radius-4 border-top-right-radius-4">
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button [iconClass]="'rc-icon-bold'" kendoEditorBoldButton />
                  <kendo-toolbar-button [iconClass]="'rc-icon-italic'" kendoEditorItalicButton />
                  <kendo-toolbar-button [iconClass]="'rc-icon-underline'" kendoEditorUnderlineButton />
                  <kendo-toolbar-button [iconClass]="'rc-icon-strikethrough'" kendoEditorStrikethroughButton />
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button
                    [iconClass]="'rc-icon-link'"
                    [rcEditorInsertLink]="body"
                    [disabled]="$any(body).view?.state?.selection?.empty ?? true" />
                  <kendo-toolbar-button [iconClass]="'rc-icon-link-off'" kendoEditorUnlinkButton />
                </kendo-toolbar-buttongroup>
              </kendo-toolbar>
            </kendo-editor>
          </kendo-formfield>
        </div>

        @let wrapperClass = hasDocuments() ? 'flex flex-row-reverse' : 'd-flex flex-column flex-grow-1 g-col-12 g-col-lg-12';
        @let formClass = hasDocuments() ? 'form-width min-w-50 max-w-50 w-50 overflow-scroll' : 'w-0';
        <rc-file-upload
          [class]="'d-flex max-h-200-px'"
          [wrapperClasses]="wrapperClass"
          [formClasses]="formClass"
          [uploadUrl]="uploadUrl"
          [isLoading]="false"
          [gridTemplateClass]="'documents-template'"
          [attachments]="media()"
          [warningAlert]="{show: false, message: ''}"
          [disabled]="false"
          [loaderIsItem]="true"
          [restrictions]="fileRestrictions"
          [dropZoneAsItem]="false"
          [extraBodyData]="extraData"
          [showNoFilesFound]="false"
          (uploadInProgress)="isUploading.set($event)"
          (updated)="updateDocumentMediaForm($event)"
          [asImageAndVideoTiles]="false">
          <ng-template #customDropZoneTemplate let-openFileDialog="openFileDialog">
            <div class="drop-zone drop-zone--documents custom-dropzone__file-select d-flex flex-column align-items-center gap-8 max-w-50 w-50 min-w-unset" [ngClass]="hasDocuments() ? 'has-documents' : 'flex-grow-1'">
              <button kendoButton type="button" class="bgc-neutral-200 fc-neutral-800 border-all-1 border-color-neutral-400 !k-w-fit" (click)="openFileDialog()">
                <span class="fw-500">{{ 'SELECT_FILE' | translate | capitalize }}</span>
              </button>
              <div class="!k-text-center">{{ 'DROP_FILES' | translate | lowercase }}</div>
            </div>
          </ng-template>
          <ng-template #customLoaderTemplate>
            <div class="d-flex align-items-center gap-12 w-100 h-50-px">
              <kendo-skeleton [style.border-radius.px]="4" shape="rectangle" animation="wave" [style.width.%]="100" [style.height.px]="50" />
            </div>
          </ng-template>
          <ng-template #itemTemplate let-file="file" let-remove="remove">
            <div class="document-row upload-file d-flex align-items-center gap-12 w-100" #fileList>
              <span rcSelectableOverflow [wrapperElement]="fileList" class="document-row__name flex-grow-1 align-content-center gap-12">{{ file.originalName || file.name }}</span>
              <div class="document-row__actions d-flex">
                <a class="media-action-button m-0 p-0" href="{{ file.contentUrl ? environment.apiUrl + file.contentUrl + '?disposition=inline' : '#' }}" target="_blank" type="button">
                  <i class="eye"></i>
                </a>
                <a class="media-action-button" href="{{ file.contentUrl ? environment.apiUrl + file.contentUrl + '?disposition=attachment' : '#' }}" type="button">
                  <i class="file"></i>
                </a>
                <button class="media-action-button" (click)="removeMedia(file['@id']!)" kendoButton type="button">
                  <i class="trash"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </rc-file-upload>
      </div>

      <div class="g-col-4 gap-24 pe-24 pt-24">
        <div class="d-flex flex-column g-col-12">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label labelCssClass="k-form-label" [for]="from" [text]="'FROM' | translate | capitalize" />
            @let senderEmails = royalCrownSenderEmails$ | async;
            <kendo-dropdownlist
              class="w-100"
              rcValidation
              #from
              [data]="getData(senderEmails)"
              [textField]="'email'"
              [valueField]="'@id'"
              [valuePrimitive]="true"
              formControlName="from" />
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-12">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label labelCssClass="k-form-label" [for]="to" [text]="'TO' | translate | capitalize" />
            <kendo-multiselect
              rcMultiSelectWrapPadding
              [data]="[]"
              (open)="onOpen($event, to)"
              [popupSettings]="{ popupClass: 'rc-free-entry-popup' }"
              [allowCustom]="true"
              rcValidation
              formControlName="to"
              #to />
          </kendo-formfield>
        </div>
      </div>
    </div>
  </form>
} @else {
  <div class="grid card-body gap-24 no-padding">
    <div class="g-col-8 gap-24 border-right-1 border-color-neutral-200 p-24 d-flex flex-column">
      <div class="d-flex flex-column gap-4">
        <kendo-skeleton shape="text" animation="wave" [style.width.px]="60" [style.height.px]="16" />
        <kendo-skeleton shape="rectangle" animation="wave" [style.width.%]="100" [style.height.px]="34" [style.border-radius.px]="4" />
      </div>
      <div class="d-flex flex-column gap-4 flex-grow-1">
        <kendo-skeleton shape="text" animation="wave" [style.width.px]="70" [style.height.px]="16" />
        <div class="d-flex gap-4" style="padding: 6px 0">
          @for (_ of [1,2,3,4]; track $index) {
            <kendo-skeleton shape="rectangle" animation="wave" [style.width.px]="28" [style.height.px]="28" [style.border-radius.px]="4" />
          }
          <div style="width: 8px"></div>
          @for (_ of [1,2]; track $index) {
            <kendo-skeleton shape="rectangle" animation="wave" [style.width.px]="28" [style.height.px]="28" [style.border-radius.px]="4" />
          }
        </div>
        <kendo-skeleton shape="rectangle" animation="wave" [style.width.%]="100" class="flex-grow-1" [style.min-height.px]="200" [style.border-radius.px]="4" />
      </div>
      <kendo-skeleton shape="rectangle" animation="wave" [style.width.%]="100" [style.height.px]="72" [style.border-radius.px]="4" />
    </div>
    <div class="g-col-4 gap-24 pe-24 pt-24 d-flex flex-column gap-16">
      <div class="d-flex flex-column gap-4">
        <kendo-skeleton shape="text" animation="wave" [style.width.px]="40" [style.height.px]="16" />
        <kendo-skeleton shape="rectangle" animation="wave" [style.width.%]="100" [style.height.px]="34" [style.border-radius.px]="4" />
      </div>
      <div class="d-flex flex-column gap-4">
        <kendo-skeleton shape="text" animation="wave" [style.width.px]="24" [style.height.px]="16" />
        <kendo-skeleton shape="rectangle" animation="wave" [style.width.%]="100" [style.height.px]="34" [style.border-radius.px]="4" />
      </div>
    </div>
  </div>
}

<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="string-button" (click)="close()">
      {{ 'CANCEL' | translate | capitalize }}
    </button>
    <button
      [disabled]="supplierComplaintSendForm().invalid"
      kendoButton
      type="submit"
      form="supplierComplaintSendForm"
      [iconClass]="'rc-icon-send'"
      [themeColor]="'primary'">
      {{ 'SEND' | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
